import { render, staticRenderFns } from "./TablePresetCreate.vue?vue&type=template&id=70664f34&"
import script from "./TablePresetCreate.vue?vue&type=script&lang=js&"
export * from "./TablePresetCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports